import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const USER_BY_UUID_RESOURCE = "user" as const;
export const USER_BY_UUID_API_PATH = `/v1/${USER_BY_UUID_RESOURCE}/{uuid}` as const;

export type UserByUuidParameters = paths[typeof USER_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type UserByUuidResponse =
  paths[typeof USER_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useUserByUuidQuery(uuid: string, options?: Options<UserByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<UserByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [USER_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<UserByUuidResponse>(`/v1/${USER_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
